import * as actions from './actions';

import { ActionType, createReducer } from 'typesafe-actions';

import { ACTION_STATUSES } from 'shared/consts';
import { TransactionsState } from 'store/transactions/types';

export const initialState: TransactionsState = {
  transactions: null,
  transaction: null,
  getTransaction: {
    status: null,
    error: null,
  },
  getTransactions: {
    status: null,
    error: null,
  },
  patchTransaction: {
    type: null,
    status: null,
    error: null,
  },
  getRedirectTransaction: {
    status: null,
    error: null,
  },
  redirectTransaction: null,
  patchTransactionId: null,
};

const getTransactionRequestHandler = (state: TransactionsState): TransactionsState => ({
  ...state,
  getTransaction: {
    error: null,
    status: ACTION_STATUSES.PENDING,
  },
});

const getTransactionSuccessHandler = (
  state: TransactionsState,
  { payload }: ActionType<typeof actions.getTransaction.success>,
): TransactionsState => ({
  ...state,
  transaction: payload,
  getTransaction: {
    error: null,
    status: ACTION_STATUSES.FULFILLED,
  },
});

const getTransactionFailureHandler = (
  state: TransactionsState,
  { payload: error }: ActionType<typeof actions.getTransaction.failure>,
): TransactionsState => ({
  ...state,
  getTransaction: {
    error: error.error,
    status: ACTION_STATUSES.REJECTED,
  },
});

const getTransactionsRequestHandler = (state: TransactionsState): TransactionsState => ({
  ...state,
  getTransactions: {
    status: ACTION_STATUSES.PENDING,
    error: null,
  },
});

const getTransactionsSuccessHandler = (
  state: TransactionsState,
  { payload }: ActionType<typeof actions.getTransactions.success>,
): TransactionsState => ({
  ...state,
  transactions: payload?.transactions,
  getTransactions: {
    status: ACTION_STATUSES.FULFILLED,
    error: null,
  },
});

const getTransactionsFailureHandler = (
  state: TransactionsState,
  { payload: error }: ActionType<typeof actions.getTransactions.failure>,
): TransactionsState => ({
  ...state,
  getTransactions: {
    status: ACTION_STATUSES.REJECTED,
    error: error.error,
  },
});

const getRedirectTransactionRequestHandler = (state: TransactionsState): TransactionsState => ({
  ...state,
  getRedirectTransaction: {
    error: null,
    status: ACTION_STATUSES.PENDING,
  },
});

const getRedirectTransactionSuccessHandler = (
  state: TransactionsState,
  { payload }: ActionType<typeof actions.getRedirectTransaction.success>,
): TransactionsState => ({
  ...state,
  redirectTransaction: payload,
  getRedirectTransaction: {
    error: null,
    status: ACTION_STATUSES.FULFILLED,
  },
});

const getRedirectTransactionFailureHandler = (
  state: TransactionsState,
  { payload: error }: ActionType<typeof actions.getRedirectTransaction.failure>,
): TransactionsState => ({
  ...state,
  getRedirectTransaction: {
    error: error.error,
    status: ACTION_STATUSES.REJECTED,
  },
});

const patchTransactionRequestHandler = (
  state: TransactionsState,
  { payload }: ActionType<typeof actions.patchTransaction.request>,
): TransactionsState => ({
  ...state,
  patchTransaction: {
    error: null,
    status: ACTION_STATUSES.PENDING,
    type: payload.status ?? payload.status_3ds,
  },
  patchTransactionId: payload.transactionId,
});

const patchTransactionSuccessHandler = (state: TransactionsState): TransactionsState => ({
  ...state,
  patchTransaction: {
    ...state.patchTransaction,
    error: null,
    status: ACTION_STATUSES.FULFILLED,
  },
});

const patchTransactionFailureHandler = (
  state: TransactionsState,
  { payload: error }: ActionType<typeof actions.patchTransaction.failure>,
): TransactionsState => ({
  ...state,
  patchTransaction: {
    ...state.patchTransaction,
    error: error.error,
    status: ACTION_STATUSES.REJECTED,
  },
  patchTransactionId: null,
});

const resetPatchTransactionHandler = (state: TransactionsState): TransactionsState => ({
  ...state,
  patchTransaction: {
    type: null,
    error: null,
    status: null,
  },
  patchTransactionId: null,
});

const resetRedirectTransactionHandler = (state: TransactionsState): TransactionsState => ({
  ...state,
  getRedirectTransaction: {
    status: null,
    error: null,
  },
  redirectTransaction: null,
});

const resetTransactionHandler = (state: TransactionsState): TransactionsState => ({
  ...state,
  transaction: null,
  getTransaction: {
    error: null,
    status: null,
  },
});

const transactionReducer = createReducer(initialState)
  .handleAction(actions.getTransaction.request, getTransactionRequestHandler)
  .handleAction(actions.getTransaction.success, getTransactionSuccessHandler)
  .handleAction(actions.getTransaction.failure, getTransactionFailureHandler)
  .handleAction(actions.getTransactions.request, getTransactionsRequestHandler)
  .handleAction(actions.getTransactions.success, getTransactionsSuccessHandler)
  .handleAction(actions.getTransactions.failure, getTransactionsFailureHandler)
  .handleAction(actions.patchTransaction.request, patchTransactionRequestHandler)
  .handleAction(actions.patchTransaction.success, patchTransactionSuccessHandler)
  .handleAction(actions.patchTransaction.failure, patchTransactionFailureHandler)
  .handleAction(actions.getRedirectTransaction.request, getRedirectTransactionRequestHandler)
  .handleAction(actions.getRedirectTransaction.success, getRedirectTransactionSuccessHandler)
  .handleAction(actions.getRedirectTransaction.failure, getRedirectTransactionFailureHandler)
  .handleAction(actions.resetPatchTransaction, resetPatchTransactionHandler)
  .handleAction(actions.resetTransaction, resetTransactionHandler)
  .handleAction(actions.resetRedirectTransaction, resetRedirectTransactionHandler);

export default transactionReducer;
